import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    isOpen: false,
    message: '',
    button1: null,
    button2: null,
    duration: 0,
  });

  const showNotification = (config) => {
    setNotification({
      isOpen: true,
      message: config.message || '',
      button1: config.button1 || null,
      button2: config.button2 || null,
      duration: config.duration || 0,
    });
  };

  const hideNotification = () => {
    setNotification((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  const value = {
    notification,
    showNotification,
    hideNotification,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};
